export default {"src":"/_next/static/media/la_certificate.ad358c52.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};